"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dialog_1 = require("@reach/dialog");
require("@reach/dialog/styles.css");
var react_1 = __importStar(require("react"));
var react_spring_1 = require("react-spring");
var shortid_1 = __importDefault(require("shortid"));
require("./Modal.scss");
var Icons_1 = require("../Icons");
var classnames_1 = __importDefault(require("classnames"));
var ModalSize;
(function (ModalSize) {
    ModalSize["BASE"] = "base";
    ModalSize["MEDIUM"] = "medium";
    ModalSize["LARGE"] = "lg";
})(ModalSize = exports.ModalSize || (exports.ModalSize = {}));
var AnimatedDialogOverlay = react_spring_1.animated(dialog_1.DialogOverlay);
var AnimatedDialogContent = react_spring_1.animated(dialog_1.DialogContent);
var Modal = function (props) {
    var children = props.children, heading = props.heading, footer = props.footer, dusk = props.dusk, _a = props.flushBody, flushBody = _a === void 0 ? false : _a, _b = props.open, open = _b === void 0 ? false : _b, onClose = props.onClose, onDestroyed = props.onDestroyed, _c = props.size, size = _c === void 0 ? ModalSize.BASE : _c;
    var transitions = react_spring_1.useTransition(open, null, {
        from: { opacity: 0, transform: 'translate(20px)' },
        enter: { opacity: 1, transform: 'translate(0)' },
        leave: { opacity: 0, transform: 'translate(320px)' },
        onDestroyed: function (destroyed) {
            destroyed && onDestroyed && onDestroyed();
        },
    });
    var labelId = react_1.useMemo(function () { return "label--" + shortid_1.default(); }, []);
    function closeModal(e) {
        e.preventDefault();
        onClose();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, transitions.map(function (_a) {
        var item = _a.item, key = _a.key, styles = _a.props;
        return item && (react_1.default.createElement(AnimatedDialogOverlay, { key: key, "data-dusk": dusk, style: { opacity: styles.opacity } },
            react_1.default.createElement(AnimatedDialogContent, { "aria-labelledby": labelId, style: { transform: styles.transform }, className: classnames_1.default('left-auto top-0 bottom-0 right-0 fixed overflow-y-auto m-0 p-0 border-t-2 border-blue', { 'modal--md': size === ModalSize.MEDIUM }, { 'modal--lg': size === ModalSize.LARGE }) },
                react_1.default.createElement("div", { className: "flex flex-col h-full" },
                    react_1.default.createElement("div", { id: labelId, className: "p-8 flex justify-between items-center" },
                        react_1.default.createElement("span", { className: "text-2xl font-semibold leading-tight" }, heading),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("button", { className: "p-1", type: "button", "aria-label": "Close modal", onClick: closeModal },
                                react_1.default.createElement(Icons_1.CloseIcon, { className: "text-blue" })))),
                    react_1.default.createElement("div", { className: "flex-grow " + (flushBody ? '' : 'px-8') }, children),
                    footer && (react_1.default.createElement("div", { className: "border-t-3 border-gray-light py-6 px-8" }, footer))))));
    })));
};
exports.default = Modal;
//# sourceMappingURL=Modal.js.map